/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationInputSendResetCodeInputModel
 */
export interface FrontApplicationInputSendResetCodeInputModel {
    /**
     * Mail pro reset
     * @type {string}
     * @memberof FrontApplicationInputSendResetCodeInputModel
     */
    email: string;
    /**
     * Client
     * @type {string}
     * @memberof FrontApplicationInputSendResetCodeInputModel
     */
    clientId: string;
    /**
     * Secret
     * @type {string}
     * @memberof FrontApplicationInputSendResetCodeInputModel
     */
    clientSecret: string;
}

/**
 * Check if a given object implements the FrontApplicationInputSendResetCodeInputModel interface.
 */
export function instanceOfFrontApplicationInputSendResetCodeInputModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientSecret" in value;

    return isInstance;
}

export function FrontApplicationInputSendResetCodeInputModelFromJSON(json: any): FrontApplicationInputSendResetCodeInputModel {
    return FrontApplicationInputSendResetCodeInputModelFromJSONTyped(json, false);
}

export function FrontApplicationInputSendResetCodeInputModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationInputSendResetCodeInputModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'clientId': json['client_id'],
        'clientSecret': json['client_secret'],
    };
}

export function FrontApplicationInputSendResetCodeInputModelToJSON(value?: FrontApplicationInputSendResetCodeInputModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'client_id': value.clientId,
        'client_secret': value.clientSecret,
    };
}

